export const GEMINI_1 = 'gemini_1';
export const GEMINI_2 = 'gemini_2';
export const SAGITTARIUS = 'sagittarius';
export const CASSIOPEIA = 'cassiopeia';
export const ANDROMEDA = 'andromeda';
export const ORION = 'orion';
export const AQUARIUS = 'aquarius';
export const CAPRICORN = 'capricorn';
export const BOREALIS = 'borealis';